<template>
    <div id="swipercom" v-if="isSmallScreen===false">
        <div class="swiper-container" id="swiperIndex">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,i) in imgs" :key="i">
                    <img :src="item.pic" alt="">
                </div>
            </div>
        </div>
    </div>
    <div id="swipercoms" v-else>
        <div class="swiper-container" id="swiperIndex">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,i) in imgs" :key="i">
                    <img :src="item.pic" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
export default {
  name: 'Swiper',
  data () {
    return {
      isSmallScreen: false,
      imgs: [
        { pic: require('@/assets/2023logoImage/sybanner.png') }
      ]
    }
  },
  mounted () {
    var swiper = new Swiper('#swiperIndex', {
      // 配置分页器内容
      loop: true, // 循环模式选项
      pagination: {
        el: '.swiper-pagination', // 换页器与哪个标签关联
        clickable: true// 分页器是否可以点击
      },
      // 自动播放
      autoplay: {
        delay: 10000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      scrollbar: {
        el: '.swiper-scrollbar'
      },
      on: {
        slideNextTransitionStart: () => {
          this.$emit('changeSwiper', 12345)
        },
        slidePrevTransitionStart: () => {
          this.$emit('addSwiper', 98765)
        }
      }
    })
    console.log(swiper)
    console.log('autoplay')
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.res5 = '../assets/footprint/tlf_qyltdn_tzjb.png'
      this.imageSrc = '../assets/image/tlf_qyltdn_tzjbbanner.png'
    } else {
      this.isSmallScreen = false
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imgs = [
        { pic: require('@/assets/image/sybanner.png') }
      ]
    } else {
      this.isSmallScreen = false
    }
  }

}
</script>

<style lang="less">
    #swipercoms{
      width: 100%;
        // height: 800.44px;
    }
    #swipercom{
        margin-top:80px ;
        width: 100%;
        // height: 800.44px;
    }
    #swiperIndex.swiper-container{
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;
            .swiper-slide img{
                width: 100%;
                // height: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }
        }
  @media screen and(max-width: 375px) {
          #swipercom{
        // width: 7.5rem;
        width: 100%;
        height: 230.94px;
        #swiperIndex.swiper-container{
            // width: 7.1rem;
            // height: 2.6rem;
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;

            .swiper-slide img{
                width: 100%;
                height: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }

        }
    }
    }
  @media screen and (max-width: 1440px) and (min-width: 1000px) {
        #swipercom{
        // width: 7.5rem;
        width: 100%;
        // height: 800.44px;
        height: 100%;
        #swiperIndex.swiper-container{
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;

            .swiper-slide img{
                width: 100%;
                height: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }
        }
    }
  }
  @media screen and (max-width: 1000px) and (min-width: 768px) {
        #swipercom{
        // width: 7.5rem;
        width: 100%;
        // height: 800.44px;
        height: 100%;
        #swiperIndex.swiper-container{
            // width: 7.1rem;
            // height: 2.6rem;
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;

            .swiper-slide img{
                width: 100%;
                height: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }

        }
    }
  }
  @media screen and (min-width: 1920px) {
        #swipercom{
        // width: 7.5rem;
        width: 100%;
        height: 1070.44px;
        #swiperIndex.swiper-container{
            // width: 7.1rem;
            // height: 2.6rem;
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;

            .swiper-slide img{
                width: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }

        }
    }
  }
  @media screen and(max-width: 414px) and (min-width: 390px) {
          #swipercom{
            position: absolute;
            left: 0;
            top: 0;
        width: 100%;
        height: 250.94px;
        #swiperIndex.swiper-container{
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;

            .swiper-slide img{
                width: 100%;
                height: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }

        }
    }
  }
  @media screen and (max-width: 1794px) and (min-width: 1541px){
     #swipercom{
        width: 100%;
        height: 800.44px;
        #swiperIndex.swiper-container{
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;

            .swiper-slide img{
                width: 100%;
                // height: 100%;
            }
            .swiper-pagination-bullet-active{
                background-color: orangered;
            }

        }
    }
  }
</style>
